import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { setupPwa } from '@/pwa';
import '@/index.css';
import 'react-toastify/dist/ReactToastify.css';

setupPwa();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
